import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export interface SummaryState {
  agreement: boolean;
}

const initialState = {
  agreement: false,
};

const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {
    update(state, action: PayloadAction<SummaryState>) {
      state.agreement = action.payload.agreement;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.agreement = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.summary?.agreement
          : initialState.agreement;
      },
    );
  },
});

export const { update, reset } = summarySlice.actions;

export const selectSummaryAgreement = (state: RootState) =>
  state.taxQuestionnaire.summary;

export default summarySlice.reducer;
